import React, { useState } from 'react';

const TechIcon = ({ name, size = 40 }) => {
  const [imageError, setImageError] = useState(false);

  // Map of technology names to their icon URLs
  const iconMap = {
    // Programming languages
    'Python': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg',
    'JavaScript': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg',
    'TypeScript': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg',
    'HTML': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg',
    'HTML/CSS': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg',
    'HTML5': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg',
    'CSS': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg',
    'CSS3': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg',
    'PHP': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg',
    'C': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg',
    'C++': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg',
    'Java': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg',
    
    // Frameworks & Libraries
    'React': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg',
    'Django': 'https://cdn.worldvectorlogo.com/logos/django.svg',
    'Flask': 'https://www.vectorlogo.zone/logos/pocoo_flask/pocoo_flask-icon.svg',
    'Bootstrap': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg',
    'Tailwind': 'https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg',
    'TailwindCSS': 'https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg',
    'Redux': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg',
    'Styled Components': 'https://miro.medium.com/v2/resize:fit:318/1*7jRD5QhgARucFKvRHFxpOg.png',
    'WebSocket': 'https://upload.wikimedia.org/wikipedia/commons/5/55/Websockets_logo.svg',
    'Node.js': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
    'Express': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg',
    'Electron': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/electron/electron-original.svg',
    'OpenAI API': 'https://upload.wikimedia.org/wikipedia/commons/0/04/ChatGPT_logo.svg',
    'jQuery': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/jquery/jquery-original.svg',
    'Font Awesome': 'https://www.vectorlogo.zone/logos/font-awesome/font-awesome-icon.svg',
    'WOW.js': 'https://raw.githubusercontent.com/graingert/WOW/master/demo/wow_logo.jpg',
    'Morphext.js': 'https://via.placeholder.com/40x40.png?text=M',
    'Superfish': 'https://via.placeholder.com/40x40.png?text=SF',
    'Sticky.js': 'https://via.placeholder.com/40x40.png?text=S',
    'Easing.js': 'https://via.placeholder.com/40x40.png?text=E',
    'Animate CSS': 'https://raw.githubusercontent.com/animate-css/animate.css/main/docs/assets/img/animatecss-opengraph.jpg',
    'Animate.css': 'https://raw.githubusercontent.com/animate-css/animate.css/main/docs/assets/img/animatecss-opengraph.jpg',
    'AOS': 'https://user-images.githubusercontent.com/8554143/33407111-49f90d08-d5b9-11e7-86dc-d7197f3b6970.png',
    'Owl Carousel': 'https://raw.githubusercontent.com/OwlCarousel2/OwlCarousel2/develop/assets/img/owl-logo.png',
    'Magnific Popup': 'https://via.placeholder.com/40x40.png?text=MP',
    'Waypoints.js': 'https://via.placeholder.com/40x40.png?text=WP',
    'ScrollAx.js': 'https://via.placeholder.com/40x40.png?text=SA',
    'Google Maps API': 'https://www.vectorlogo.zone/logos/google_maps/google_maps-icon.svg',
    'Google Fonts': 'https://www.vectorlogo.zone/logos/google_fonts/google_fonts-icon.svg',
    'Vite': 'https://vitejs.dev/logo.svg',
    'shadcn/ui': 'https://avatars.githubusercontent.com/u/124599?v=4',
    'Supabase': 'https://www.vectorlogo.zone/logos/supabase/supabase-icon.svg',
    'Google Gemini API': 'https://www.gstatic.com/lamda/images/gemini_sparkle_v002_256px.gif',
    'Clerk Authentication': 'https://images.clerk.dev/static/logo.svg',
    'React Query': 'https://react-query-v3.tanstack.com/_next/static/images/emblem-light-628080660fddb35787ff6c77e97ca43e.svg',
    'React Router': 'https://reactrouter.com/_brand/react-router-mark-color.svg',
    'Radix UI': 'https://avatars.githubusercontent.com/u/75042455?s=48&v=4',
    'Lucide React': 'https://lucide.dev/logo.light.svg',
    'React Hook Form': 'https://avatars.githubusercontent.com/u/53986236?s=48&v=4',
    'Zod': 'https://zod.dev/logo.svg',
    'React Markdown': 'https://via.placeholder.com/40x40.png?text=RM',
    'jsPDF': 'https://raw.githubusercontent.com/parallax/jsPDF/master/docs/images/logo.png',
    'Recharts': 'https://recharts.org/static/media/logo.58e4b39f.svg',
    'Date-fns': 'https://date-fns.org/static/logo.svg',
    'EmailJS': 'https://www.emailjs.com/logo.png',
    'Framer Motion': 'https://www.framer.com/images/favicons/favicon.svg',
    'Shadcn UI': 'https://avatars.githubusercontent.com/u/124599?v=4',
    'Swiper': 'https://swiperjs.com/images/swiper-logo.svg',
    'django-countries': 'https://cdn.worldvectorlogo.com/logos/django.svg',
    'django-bootstrap-form': 'https://cdn.worldvectorlogo.com/logos/django.svg',
    'QR Code Generator': 'https://www.qrcode-monkey.com/img/default-preview-qr.svg',
    
    // Databases
    'PostgreSQL': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg',
    'MySQL': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg',
    'MongoDB': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg',
    'SQLite': 'https://www.vectorlogo.zone/logos/sqlite/sqlite-icon.svg',
    
    // Tools & Platforms
    'Git': 'https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg',
    'Linux': 'https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg',
    'Netlify': 'https://www.vectorlogo.zone/logos/netlify/netlify-icon.svg',
    'Heroku': 'https://www.vectorlogo.zone/logos/heroku/heroku-icon.svg',
    'Docker': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg',
  };

  // Documentation links
  const docLinks = {
    'Python': 'https://www.python.org',
    'JavaScript': 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
    'TypeScript': 'https://www.typescriptlang.org',
    'HTML': 'https://developer.mozilla.org/en-US/docs/Web/HTML',
    'HTML5': 'https://developer.mozilla.org/en-US/docs/Web/HTML',
    'HTML/CSS': 'https://developer.mozilla.org/en-US/docs/Web/HTML',
    'CSS': 'https://developer.mozilla.org/en-US/docs/Web/CSS',
    'CSS3': 'https://developer.mozilla.org/en-US/docs/Web/CSS',
    'PHP': 'https://www.php.net',
    'React': 'https://reactjs.org',
    'Django': 'https://www.djangoproject.com',
    'Flask': 'https://flask.palletsprojects.com',
    'Bootstrap': 'https://getbootstrap.com',
    'Tailwind': 'https://tailwindcss.com',
    'TailwindCSS': 'https://tailwindcss.com',
    'PostgreSQL': 'https://www.postgresql.org',
    'MySQL': 'https://www.mysql.com',
    'MongoDB': 'https://www.mongodb.com',
    'SQLite': 'https://www.sqlite.org',
    'Redux': 'https://redux.js.org',
    'Styled Components': 'https://styled-components.com',
    'Node.js': 'https://nodejs.org',
    'Express': 'https://expressjs.com',
    'WebSocket': 'https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API',
    'Netlify': 'https://www.netlify.com',
    'Git': 'https://git-scm.com',
    'Linux': 'https://www.linux.org',
    'C': 'https://www.cprogramming.com',
    'C++': 'https://www.w3schools.com/cpp',
    'Java': 'https://www.java.com',
    'Docker': 'https://www.docker.com',
    'Electron': 'https://www.electronjs.org',
    'OpenAI API': 'https://openai.com/api',
    'jQuery': 'https://jquery.com',
    'Font Awesome': 'https://fontawesome.com',
    'WOW.js': 'https://wowjs.uk',
    'Morphext.js': 'https://morphext.fyianlai.com',
    'Superfish': 'https://superfish.joelbirch.design',
    'Sticky.js': 'https://github.com/garand/sticky',
    'Easing.js': 'https://gsgd.co.uk/sandbox/jquery/easing',
    'Animate CSS': 'https://animate.style',
    'Animate.css': 'https://animate.style',
    'AOS': 'https://michalsnik.github.io/aos',
    'Owl Carousel': 'https://owlcarousel2.github.io/OwlCarousel2',
    'Magnific Popup': 'https://dimsemenov.com/plugins/magnific-popup',
    'Waypoints.js': 'http://imakewebthings.com/waypoints',
    'ScrollAx.js': 'https://github.com/samiare/scroll-ax',
    'Google Maps API': 'https://developers.google.com/maps',
    'Google Fonts': 'https://fonts.google.com',
    'Vite': 'https://vitejs.dev',
    'shadcn/ui': 'https://ui.shadcn.com',
    'Supabase': 'https://supabase.com',
    'Google Gemini API': 'https://ai.google.dev/gemini-api',
    'Clerk Authentication': 'https://clerk.com',
    'React Query': 'https://tanstack.com/query',
    'React Router': 'https://reactrouter.com',
    'Radix UI': 'https://www.radix-ui.com',
    'Lucide React': 'https://lucide.dev',
    'React Hook Form': 'https://react-hook-form.com',
    'Zod': 'https://zod.dev',
    'React Markdown': 'https://github.com/remarkjs/react-markdown',
    'jsPDF': 'https://parall.ax/products/jspdf',
    'Recharts': 'https://recharts.org',
    'Date-fns': 'https://date-fns.org',
    'EmailJS': 'https://www.emailjs.com',
    'Framer Motion': 'https://www.framer.com/motion',
    'Shadcn UI': 'https://ui.shadcn.com',
    'Swiper': 'https://swiperjs.com',
    'django-countries': 'https://github.com/SmileyChris/django-countries',
    'django-bootstrap-form': 'https://github.com/tzangms/django-bootstrap-form',
    'QR Code Generator': 'https://www.qrcode-monkey.com',
  };

  // Get icon URL from map or use default icon
  const iconUrl = iconMap[name] || `https://via.placeholder.com/40x40.png?text=${name[0]}`;
  
  // Get documentation link or use a default
  const docLink = docLinks[name] || '#';

  // Handle image loading errors
  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className="tech-icon-wrapper" title={name}>
      <a 
        href={docLink} 
        target="_blank" 
        rel="noopener noreferrer"
        className="tech-icon-link"
      >
        {imageError ? (
          <div className="tech-icon-fallback">
            {name.charAt(0)}
          </div>
        ) : (
          <img 
            src={iconUrl} 
            alt={name} 
            width={size} 
            height={size} 
            className="tech-icon"
            onError={handleImageError}
          />
        )}
        <span className="tech-name">{name}</span>
      </a>
    </div>
  );
};

export default TechIcon; 